// extracted by mini-css-extract-plugin
export default {"module":"input_module__8Lyin"};